// extracted by mini-css-extract-plugin
export var featuresMatrixDesktop = "FeaturesMatrix-module--featuresMatrixDesktop--e7176";
export var featuresMatrixMobile = "FeaturesMatrix-module--featuresMatrixMobile--d2efe";
export var selectLabel = "FeaturesMatrix-module--selectLabel--3e598";
export var selectSection = "FeaturesMatrix-module--selectSection--a01a9";